export { PLUGIN_KEY, PLUGIN_PRIORITY, ContextMenu } from "./contextMenu.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/contextMenu/index.mjs
// module id = 1292
// module chunks = 1